import { createSlice } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';

import { LessonTaskStepKeys } from '../../../main/constants/lesson-task-step-keys.ts';
import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { PROGRESS_SLICE_NAME, ProgressSliceState } from './progress.slice.types.ts';
import { completeStepThunkExtraReducers } from './thunks/complete-step.thunk.ts';
import { refreshLastCompletedStepThunkExtraReducers } from './thunks/refresh-last-completed-step.thunk.ts';

export const PROGRESS_SLICE_INITIAL_STATE: ProgressSliceState = {
  lastCompletedStep: undefined,
  lastCompletedStepTemp: undefined,
};

const persistKeys: (keyof ProgressSliceState)[] = ['lastCompletedStep'];

const progressSlice = createSlice({
  name: PROGRESS_SLICE_NAME,
  initialState: PROGRESS_SLICE_INITIAL_STATE,
  reducers: {
    resetProgressSlice: (_state) => {
      return PROGRESS_SLICE_INITIAL_STATE;
    },
    resetLessonTempProgress: (state) => {
      state.lastCompletedStepTemp = LessonTaskStepKeys.DEFAULT_LAST_COMPLETED;
    },
  },
  extraReducers: (builder) => {
    refreshLastCompletedStepThunkExtraReducers(builder);
    completeStepThunkExtraReducers(builder);
  },
});

const persistConfig: PersistConfig<ProgressSliceState> = {
  key: PROGRESS_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: persistKeys,
};

export const { resetProgressSlice, resetLessonTempProgress } = progressSlice.actions;

export const ProgressSlice = persistReducer(persistConfig, progressSlice.reducer);
